import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import Banner1 from '../../images/banner/banner1.jpg';
import PortImage10 from '../../images/industrie/petro.jpg';
import ClientLogo1 from '../elements/client-logo/client-logo-1';

class IndustryPetrochemicals extends Component {

	render(){
		return (
			<>
				<Header1 />
				
				<div className="page-content bg-white">

					<div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
						<div className="container">
							<div className="page-banner-entry">
								<h1 className="text-white">Petrochemicals</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
										<li>Industries</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					<div className="content-block" id="content-area">
						
						<div className="section-area section-sp2 port-7-content">
							<div className="container">
								<div className="row">
									
									<div className="col-lg-7">
										<div className="heading-bx text-left m-b20">
											<h3 className="title-head m-b0">Petrochemical Solutions</h3>
											<div className="ttr-separator sepimg"></div>
										</div>

										<p>
											GO-PS provides integrated technical and operational support to petrochemical plants, covering the full spectrum of processing units and transformation technologies. We deliver expertise in process optimisation, advanced control systems, and the supply of specialised industrial equipment adapted to complex petrochemical environments.

                                           <br/><br/>Our capabilities include catalyst selection and performance monitoring, corrosion mitigation strategies, materials engineering, and predictive maintenance programmes designed to reduce unplanned shutdowns.

											<br/><br/>By enhancing plant efficiency, reinforcing asset reliability, and improving operational safety, our teams ensure that petrochemical facilities operate at peak performance while maintaining compliance with international standards and environmental regulations.
										</p>
									</div>

									<div className="col-lg-5">
										<div className="row sp4 magnific-image sticky-top">
											<div className="action-card col-lg-12 wow fadeInUp">
												<div className="portfolio-box">
													<div className="portfolio-media">
														<img src={PortImage10} alt="" style={{ border: "6px solid #ff6600"  }}/>
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>

					</div>
                    <div className="section-area section-sp2 bg-gray">
							<div className="container wow fadeIn" data-wow-delay="0.8s">
								<div className="heading-bx text-center">
									<h6 className="title-ext m-b0">Our Partner</h6>
									<h2 className="title-head m-b0">Partners & Clients</h2>
									<div className="ttr-separator sepimg"></div>
								</div>
								
								<ClientLogo1 />
						
							</div>
						</div>
				</div>

				<Footer1 />
			</>
		);
	}
}

export default IndustryPetrochemicals;
